import { CssBaseline, ThemeProvider } from "@mui/material";
import { AppTheme } from "./themes/AppTheme";
import { QueryClient, QueryClientProvider } from "react-query";
import { Fragment } from "react";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import "reactflow/dist/style.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./components/auths/LoginPage";
import { UserProvider } from "./context/UserProvider";
import { UserAuth, isLoggedIn } from "./utils/util";
import Logout from "./components/auths/LogOut";
import HomeDash from "./components/HomeDash";
import TemplateView from "./components/templates/TemplateView";
import CreateSubmitTemplate from "./components/templates/CreateSubmitTemplate";
import TrackCampaign from "./components/campaign/TrackCampaign";
import CampaignChats from "./components/campaign/CampaignChats";
import TemplateBuilder from "./components/CreateTemplate";
import { DialogProvider } from "./context/DialogContext";
import UserRegistration from "./components/profile/UserRegistration";
import PaymentWidget from "./components/payments/PaymentWidget";
import ChatbotFlowBuilder from "./components/autoreply/flows/ChatbotFlowBuilder";
import EcommercePage from "./components/ecommerce/EcommercePage";
import ChatInterface from "./ai/ChatInterface";
import MarketingAnalysis from "./components/ecommerce/MarketingAnalysis";
import MarketingContactsAnalysis1 from "./components/ecommerce/MarketingAnalysis1";
import SelfOnBoarding from "./components/SelfOnBoarding";
import EmailUser from "./components/containers/EmailUser";
import SetCustomerPassword from "./components/containers/SetCustomerPassword";
import LinkPhoneNumber from "./components/containers/LinkPhoneNumber";
import PasswordRecovery from "./components/auths/PasswordResetLink";
import AccountLink from "./components/accounts/AccountLink";
import PricingPlansNew from "./components/accounts/PricingPlansNew";
import DownloadLeads from "./components/accounts/DownloadLeads";
import AccountExpiredCard from "./components/accounts/AccountExpiredCard";
import ContactsAnalysisDashboard from "./components/database/analysis/DatabaseAnalysis";
import ChatAiInterface from "./ai/ChatAiInterface";
import ImageSelectorExample from "./widgets/ImageSelectorExample";
import USeAiImage from "./ai/USeAiImage";
import LeadsReports from "./components/pages/LeadsReports";
import RechargeHub from "./components/reseller/RechargeHub";
import RechargeComponentReseller from "./components/payments/RechargeComponentReseller";

const queryClient = new QueryClient();

const App = () => {
  return (
    <ThemeProvider theme={AppTheme}>
      <QueryClientProvider client={queryClient}>
        <DialogProvider>
          <Fragment>
            <CssBaseline />
            <BrowserRouter>
              <ToastContainer autoClose={1500} />
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route
                  path="/login"
                  element={
                    isLoggedIn() ? (
                      <Navigate to="/home" replace />
                    ) : (
                      <LoginPage />
                    )
                  }
                />
                <Route path="/logout" element={<Logout />} />
                <Route path="/template-view/:id" element={<TemplateView />} />
                <Route path="/track-campaign" element={<TrackCampaign />} />
                <Route path="payment-widget" element={<PaymentWidget />} />
                <Route path="chat-ai" element={<ChatInterface />} />
                <Route path="image-select" element={<ImageSelectorExample />} />
                <Route path="marketing-ai" element={<MarketingAnalysis />} />

                <Route
                  path="/account-expired"
                  element={<AccountExpiredCard />}
                />
                <Route
                  path="/database-analysis"
                  element={<ContactsAnalysisDashboard />}
                />
                <Route path="/ai-interface" element={<ChatAiInterface />} />
                <Route
                  path="marketing-ai-1"
                  element={<MarketingContactsAnalysis1 />}
                />
                <Route
                  path="/campaign-chats/:cusId/:campaignName"
                  element={<CampaignChats />}
                />
                <Route
                  path="/account-link/:wabaId/:phoneId"
                  element={<AccountLink />}
                />
                <Route path="/pricing-plans" element={<PricingPlansNew />} />
                <Route path="/download-leads/:id" element={<DownloadLeads />} />
                <Route path="/create-user" element={<EmailUser />} />
                <Route
                  path="/set-password/:id"
                  element={<SetCustomerPassword />}
                />
                <Route
                  path="/link-phonenumber/:id"
                  element={<LinkPhoneNumber />}
                />
                <Route path="/reset-password" element={<PasswordRecovery />} />
                <Route
                  path="/:id/chatbot-flow-builder"
                  element={<ChatbotFlowBuilder />}
                />
                <Route
                  path="self-onboarding/:id"
                  element={<SelfOnBoarding />}
                />
                <Route path=":id/get-leads" element={<LeadsReports />} />
                <Route path=":id/reseller" element={<RechargeHub />} />
                <Route
                  path=":id/reseller-recharge"
                  element={<RechargeComponentReseller />}
                />
                <Route path="/image-generate" element={<USeAiImage />} />
                <Route path="/register" element={<UserRegistration />} />
                <Route path="/ecommerce-page" element={<EcommercePage />} />
                <Route path="/template-builder" element={<TemplateBuilder />} />
                <Route
                  path="/home/*"
                  element={
                    <UserProvider>
                      <UserAuth>
                        <HomeDash />
                      </UserAuth>
                    </UserProvider>
                  }
                />
              </Routes>
            </BrowserRouter>
          </Fragment>
        </DialogProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
